import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function textSearchFilterIcon(theme: Theme): ComponentStyle {
  return {
    componentName: 'textSearchFilterIcon',
    baseStyle: {
      paddingLeft: theme.space['2xs']
    }
  };
}
